<div class="wrapper wrapper-content animated fadeInRight playoff-workspace">
  @if (isLoading()) {
    <div class="text-center m-t-lg">
      <i class="fa fa-refresh fa-spin fa-2x text-muted"></i>
      <p class="text-muted m-t-sm">Loading playoff detail…</p>
    </div>
  } @else {
    @if (error(); as errorMessage) {
      <div class="alert alert-warning m-b-md">
        <i class="fa fa-exclamation-triangle m-r-xs"></i>
        {{ errorMessage }}
      </div>
    }
    @if (detail(); as playoffDetail) {
      <div class="row m-b-lg">
        <div class="col-lg-8 col-md-7">
          <div class="page-heading">
            <h2 class="page-title m-b-none">
              {{ playoffDetail.tournamentName }}
            </h2>
            <small class="text-muted">Playoff summary and management hub</small>
          </div>
        </div>
        @if (playoffDetail.course; as course) {
          <div
            class="col-lg-4 col-md-5 text-right"
            >
            <div class="playoff-meta">
              <span class="label label-primary m-r-xs">{{ course.name }}</span>
              <span class="label label-info">{{ course.shortName }}</span>
            </div>
          </div>
        }
      </div>
      <app-playoff-management
        [detail]="playoffDetail"
        [tournament]="currentTournament"
      ></app-playoff-management>
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5>Playoff Leaderboard</h5>
              @if (holes().length) {
                <div class="ibox-tools">
                  <span class="label label-default"
                    >{{ holes().length }} holes</span
                    >
                  </div>
                }
              </div>
              <div class="ibox-content">
                @if (holes().length > 0) {
                  <div
                    class="table-responsive"
                    >
                    <table
                      class="table table-striped table-bordered table-hover playoff-score-table"
                      >
                      <thead>
                        <tr>
                          <th class="player-column">Player</th>
                          <th class="status-column">Status</th>
                          @for (hole of holes(); track trackHole($index, hole)) {
                            <th
                              class="hole-column"
                              >
                              <div class="hole-header">
                                <div class="hole-number">H{{ hole.number }}</div>
                                <div class="hole-meta text-muted small">
                                  <span class="hole-sequence"
                                    >Seq: {{ hole.sequence }}</span
                                    >
                                    <span class="hole-par m-l-xs"
                                      >Par: {{ hole.par }}</span
                                      >
                                    </div>
                                  </div>
                                </th>
                              }
                              <th class="total-column">Total</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (player of players(); track trackPlayer($index, player)) {
                              <tr>
                                <td class="player-column">
                                  <div class="player-name">
                                    {{ player.firstName }} {{ player.lastName }}
                                    @if (player.isAmateur) {
                                      <span
                                        class="label label-default m-l-xs"
                                        >Am</span
                                        >
                                      }
                                    </div>
                                    <div class="player-meta text-muted small">
                                      {{ player.country || "—" }} • LPGA
                                      {{ player.lpgaId || "N/A" }}
                                    </div>
                                  </td>
                                  <td class="status-column">
                                    <select
                                      class="form-control status-select"
                                      [value]="player.status"
                                      (change)="onStatusChange(player, $event)"
                                      >
                                      <option value="ACT">Active</option>
                                      <option value="WNR">Winner</option>
                                      <option value="ELM">Eliminated</option>
                                    </select>
                                  </td>
                                  @for (hole of holes(); track trackHole($index, hole)) {
                                    <td
                                      class="score-column"
                                      [ngClass]="scoreClass(player, hole)"
                                      >
                                      <input
                                        type="number"
                                        class="form-control score-input"
                          [value]="
                            scoreForHole(player, hole) === '—'
                              ? ''
                              : scoreForHole(player, hole)
                          "
                                        (blur)="onScoreChange(player, hole, $event)"
                                        [attr.data-verified]="isScoreVerified(player, hole)"
                                        min="1"
                                        max="20"
                                        />
                                      </td>
                                    }
                                    <td class="total-column">
                                      {{ totalForPlayer(player) }}
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        } @else {
                          <div class="alert alert-info m-b-none">
                            <i class="fa fa-info-circle m-r-xs"></i>
                            No playoff holes have been configured yet.
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            }

          </div>
